export default __webpack_public_path__ + "static/media/filter.ff19210a.svg";